import React from 'react'
import { InsightContentSettingType } from 'components/insightContent/types'
import CountType from 'enums/CountType'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import MeasurementType from 'enums/MeasurementType'

import SharedTotalMeasure from '../SharedTotalMeasure'
import Title from './Title'

const StarRatingsTotalMeasure = ({
  detailSetting,
  timeUnits,
  forceNotScale
}: {
  detailSetting: InsightContentSettingType
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
}) => {
  const alteredDetailSetting = {
    ...detailSetting,
    filter: {
      ...detailSetting.filter,
      excludedStarRatings: [{ type: MeasurementType.STAR, overallChecked: true, values: [-1, -2] }]
    }
  }

  return (
    <SharedTotalMeasure
      detailSetting={alteredDetailSetting}
      countType={CountType.POSTS}
      timeUnits={timeUnits}
      forceNotScale={forceNotScale}
      title={<Title />}
    />
  )
}
export default StarRatingsTotalMeasure
